import { render } from "./MyFooter.vue?vue&type=template&id=54651491&scoped=true"
import script from "./MyFooter.vue?vue&type=script&lang=js"
export * from "./MyFooter.vue?vue&type=script&lang=js"

import "./MyFooter.vue?vue&type=style&index=0&id=54651491&scoped=true&lang=css"

import exportComponent from "D:\\0my-projects\\myweb2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54651491"]])

export default __exports__